var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.985 511.985",
    style: {
      enableBackground: "new 0 0 511.985 511.985"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M490.111,0H276.773c-5.891,0-10.672,4.765-10.672,10.655v192.011c0,5.89,4.781,10.655,10.672,10.655 h31.999v42.671l85.341-42.671h95.998c5.891,0,10.656-4.766,10.656-10.655V10.655C500.767,4.764,496.002,0,490.111,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A437"
    },
    d: "M268.601,434.424H51.389c0,0-56.623-263.741,108.606-263.741 C325.209,170.682,268.601,434.424,268.601,434.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M281.898,428.221l-1.203-0.344c-17.641-4.733-23.609-9.296-31.468-12.28 c-27.859-10.608-35.108-18.265-36.968-21.874c-0.062-0.141-0.109-0.281-0.172-0.406l-0.234-32.359l-51.858-0.749l-51.858,0.749 l-0.234,32.359c-0.062,0.125-0.109,0.266-0.172,0.406c-1.859,3.609-9.109,11.266-36.968,21.874 c-7.859,2.984-13.828,7.547-31.468,12.28l-1.219,0.344c-16.062,5.312-26.858,20.203-26.858,37.016v46.748h148.777h148.777v-46.748 C308.772,448.424,297.961,433.533,281.898,428.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M251.681,298.021c0,59.577-56.795,114.403-91.685,114.403c-34.905,0-91.701-54.826-91.701-114.403 c0-59.576,41.062-98.887,91.701-98.887S251.681,238.445,251.681,298.021z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE54"
    },
    points: "176.761,237.884 94.216,292.71 63.967,299.959 71.107,261.148 91.388,207.524  148.277,187.088 214.947,191.525 242.946,239.523 250.962,274.944 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M277.211,314.381c-3.047-48.123-16.047-98.372-52.702-124.809l-41.733,34.812l-12.031,17.624 l106.31,72.592L277.211,314.381z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED5564"
    },
    points: "412.16,120.683 415.441,117.48 440.893,92.684 405.722,87.575 401.191,86.903 399.16,82.794  383.442,50.935 367.709,82.794 365.693,86.903 361.146,87.575 325.99,92.684 351.428,117.48 354.709,120.683 353.943,125.199  347.928,160.214 379.38,143.682 383.442,141.542 387.489,143.682 418.941,160.214 412.941,125.199 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M42.561,318.178c41.468-7.562,87.294-30.062,136.23-66.92c29.171-21.983,50.499-42.437,58.592-50.498 c-17.718-18.422-42.639-30.077-77.388-30.077C70.842,170.682,46.28,247.461,42.561,318.178z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewSurvey);
export default __webpack_public_path__ + "static/media/review-survey.d2edca0150eddbac32c3b46f24f67eec.svg";
export { ForwardRef as ReactComponent };